module.exports = __webpack_public_path__ + "053d162ace67af999ab3edc6680d74fa.gif";